import { GetServerSideProps } from 'next';
import { useCallback, useContext } from 'react';

import { CookiePreferencesBannerContext } from '@/components/app/layout/CookiePreferencesBannerProvider';
import Layout from '@/components/layout/LayoutWrapper';
import EnPrivacyPolicyMDX from '@/markdown/terms/health-data-privacy-policy/en.mdx';
import { Locale } from '@/store/locale/types';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

interface HealthDataPrivacyProps {
	meta: {
		title: string;
	};
	initialState: { locale: Locale };
}

/*
 * Need to use switch statement due to need for static strings in `import` function within `dynamic()`
 * https://nextjs.org/docs/advanced-features/dynamic-import
 * This might eventually get fixed: https://github.com/vercel/next.js/discussions/33980
 */
const localeMdx = (locale: Locale = 'en') => {
	switch (locale) {
		// Internationalization not yet implemented.
		default:
			return EnPrivacyPolicyMDX;
	}
};

const HealthDataPrivacy = ({ initialState: { locale } }: HealthDataPrivacyProps) => {
	const LocaleMdx = localeMdx(locale);
	const { setCanBeShown, setIsAnnounced, setIsForciblyShown } = useContext(CookiePreferencesBannerContext);
	const openCookiesBanner = useCallback(() => {
		setCanBeShown(true);
		setIsAnnounced(true);
		setIsForciblyShown(true);
	}, [setIsAnnounced, setIsForciblyShown, setCanBeShown]);

	// TODO: refactor this code to follow best practices
	/* eslint-disable react-hooks/static-components */
	return (
		<Layout
			pageName="calm-consumer-health-data-privacy-policy"
			title="Calm - Consumer Health Data Privacy Policy"
		>
			<LocaleMdx onOptOutClick={openCookiesBanner} />
		</Layout>
	);
	/* eslint-enable react-hooks/static-components */
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState,
			hideAcceptCookiesModal: true,
		},
	};
};

export default HealthDataPrivacy;
